import {MatrimonialProfile} from '../../api/response/matrimonial';

export enum MatrimonialActionType {
  ProfileList = 'ProfileList',
}

export interface MatrimonialState {
  matrimonialProfiles: MatrimonialProfile[];
}
